// Libs
import { useTranslation } from 'react-i18next';
import { Button, Modal, TextInput } from '@instructure/ui';
import { useState } from 'react';
// Components, Layouts, Pages
// Others

type Props = {
  isOpen: boolean;
  onSubmit: (code: string) => void;
};

const ModalFillAccessCodeComponent = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, onSubmit } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/quiz', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [accessCode, setAccessCode] = useState('');
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (accessCode.trim()) {
      setAccessCode('');
      onSubmit(accessCode.trim());
    }
  };
  //#endregion Handle Function

  return (
    <Modal
      open={isOpen}
      as='form'
      size='auto'
      label='Modal Fill Access Code'
      shouldCloseOnDocumentClick
      onSubmit={handleSubmit}
    >
      <Modal.Body>
        <TextInput
          type='password'
          renderLabel={t('quiz_access_code_notify')}
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='primary' type='submit' disabled={!accessCode.trim()}>
          {t('submit_button_label', { ns: 'common/base' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFillAccessCodeComponent;
